import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "43",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F3B416",
      d: "M30.923 11.875v25.943A5.18 5.18 0 0 1 25.741 43H5.181A5.18 5.18 0 0 1 0 37.818V5.182A5.18 5.18 0 0 1 5.182 0h13.866z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F6CA5A",
      d: "M30.923 11.875H21.19a2.14 2.14 0 0 1-2.142-2.141V0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M13.01 20.366v8.525H11.8v-3.318c.025-.974.05-1.864.1-2.754l-.05-.026c-.243.68-.537 1.462-.831 2.243l-.748 1.931H9.055l-.74-1.931c-.293-.781-.587-1.562-.83-2.243l-.051.026c.033.89.075 1.78.1 2.754v3.318H6.325v-8.525h1.252l1.436 3.46c.193.488.487 1.302.621 1.697h.05c.135-.386.429-1.21.622-1.697l1.436-3.46zM19.585 23.12c0 1.79-.949 2.78-2.62 2.78h-1.024v2.99h-1.227v-8.524h2.251c1.671 0 2.62 1.016 2.62 2.755m-1.26 0c0-1.049-.453-1.586-1.377-1.586H15.94v3.191h1.008c.933 0 1.378-.504 1.378-1.604M24.59 25.935v.562c0 1.655-.755 2.537-2.216 2.537-1.344 0-2.192-.84-2.226-2.436h1.167c.05.949.429 1.293 1.033 1.293.731 0 1.059-.428 1.059-1.402v-.52c0-.942-.437-1.27-1.185-1.27h-.78v-.83l1.494-2.428h-2.51v-1.083h3.946v.806l-1.629 2.595c1.226.06 1.848.983 1.848 2.175"
    }, null, -1)
  ])))
}
export default { render: render }